import { render, staticRenderFns } from "./ProductSpec.vue?vue&type=template&id=6ba32796&"
import script from "./ProductSpec.vue?vue&type=script&lang=js&"
export * from "./ProductSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductSpec.vue"
export default component.exports